import React from 'react';

class LegacyUtils extends React.Component {
    render() {
        return null;
    }
}
export default LegacyUtils;
